<template>
    <el-dialog :close-on-click-modal="false" width="41%" :title="$t('IMPORT_ACCOUNT_BTN')" :visible="visible" @close="onDialogClose">
        <div class="form-wrapper">
            <div class="form-label">
                {{$t('ACCOUNT_FILE_NAME_LABEL')}}
            </div>
            <div class="form-component">
                <el-upload class="logo-uploader" action="url" :http-request="uploadFiles" :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUpload">
                    <el-input readonly suffix-icon="el-icon-folder-opened" v-model="fileName"></el-input>
                </el-upload>
            </div>
        </div>
        <div v-show="errorMessage" class="form-wrapper error-message">
            <div class="form-label">{{$t('ERROR_DETAIL_LABEL')}}</div>
            <div class="form-component">
                <div>{{errorMessage}}</div>
            </div>
        </div>
        <div style="color: #fd349c"><i class="el-icon-warning" />{{ $t('account_upload_info')}}</div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="download">{{$t('COMMON_DOWNLOAD_TEMP')}}</el-button>
            <el-button type="primary" @click="onDialogClose" class="wl-green">{{$t('CLOSE_BUTTON')}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api'
    import { loading, isIE } from '@/utils'
    import {mapGetters} from "vuex";
    export default {
        name: "import-account",
        data(){
            return {
                fileName: '',
                errorMessage: '',
                loading: loading(),
            }
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite'
            }),
        },
        watch: {
            visible(n, o) {
                this.errorMessage = ''
                this.fileName = ''
            }
        },
        props: {
            visible: Boolean,
            groupId: String
        },
        methods: {
            onDialogClose() {
                this.$emit('onDialogClose')
            },
            async download() {
                try {
                    const res = await API.pbc.downloadAccountTemplate()
                    if (res) {
                        let blob = new Blob([res])
                        if (isIE()) {
                            navigator.msSaveBlob(blob, 'AccountImportTemplate.xlsx')
                        } else {
                            let url = window.URL.createObjectURL(blob)
                            let link = document.createElement('a')
                            link.style.display = 'none'
                            link.href = url
                            link.setAttribute('download', 'AccountImportTemplate.xlsx')
                            document.body.appendChild(link)
                            link.click()
                        }
                    }
                }
                catch(e) {}
                finally {}
            },
            handleSuccess(res, file) {
            },
            beforeUpload(file) {
                const isExcel =
                    file.type === 'application/vnd.ms-excel' ||
                    file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                    file.type === 'image/png'
                const isLt2M = file.size / 1024 / 1024 < 5

                if (!isExcel) {
                    this.$message.error(this.$t('import_file_type_error'))
                }
                if (!isLt2M) {
                    this.$message.error(this.$t('import_file_size_error'))
                }
                return isExcel && isLt2M
            },
            uploadFiles(item) {
                this.fileName = item.file.name
                let fileParams = new FormData()
                fileParams.append('siteId', this.getSite.siteId)
                fileParams.append('file', item.file)
                fileParams.append('groupId', this.groupId)
                this.upload(fileParams)
            },
            async upload(fileParams) {
                this.loading.upload();
                try {
                    const {
                        data,
                        code,
                        errDetails
                    } = await API.pbc.uploadAccountFile(fileParams)
                    if (code == '1') {
                        this.$message.success(this.$t('file_upload_success'))
                        this.$emit('on-upload-success',data)
                    } else {
                        this.errorMessage = this.$t(errDetails.msg)
                    }
                } catch (e) {
                    this.$message.error(e)
                } finally {
                    this.loading.close()
                }
            }
        }
    }
</script>

<style scoped>
.form-wrapper{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.form-wrapper:first-child {
    margin-bottom: 20px;
}

.form-wrapper .form-label {
    min-width: 120px;
}
.error-message {
    color: #f56c6c;
    font-size: 14px;
}
</style>